"use client"
import * as React from "react"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import Stack from "@mui/material/Stack"
import Collapse from "@mui/material/Collapse"
import ExpandLess from "@mui/icons-material/ExpandLess"
import ExpandMore from "@mui/icons-material/ExpandMore"
import HomeRoundedIcon from "@mui/icons-material/HomeRounded"
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded"
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded"
import { Link, useLocation } from "react-router-dom";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
// import {BUSINESS_TYPES} from "@/app/constants/businessTypes";
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import CategoryIcon from '@mui/icons-material/Category';
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import ShopIcon from '@mui/icons-material/Shop';
import CampaignIcon from '@mui/icons-material/Campaign';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';

const mainListItems = [
  { text: "Dashboard", icon: <HomeRoundedIcon />, href: "/admin" },
  // { text: "Users", icon: <PeopleRoundedIcon />, href: "/admin/users" },
  { text: "Projects", icon: <CategoryIcon />, href: "/admin/projects" },
  { text: "Requests", icon: <QueryBuilderIcon />, href: "/admin/requests" },
];

export default function MenuContent() {
    const location = useLocation()
    const pathname = location.pathname
    // State to track which expandable menus are open
    const [openMenus, setOpenMenus] = React.useState({})

    const handleMenuClick = (menuText) => {
        setOpenMenus(prev => ({
            ...prev,
            [menuText]: !prev[menuText]
        }))
    }

    // Check if any sub-item of an expandable menu is active
    const isMenuActive = (subItems) => {
        return subItems.some(item => pathname === item.href)
    }

    return (
        <Stack sx={{ flexGrow: 1, p: 1, justifyContent: "space-between" }}>
            <List dense>
                {mainListItems.map((item, index) => (
                    <ListItem key={index} disablePadding sx={{ display: "block" }}>
                        <Link to={item.href} style={{ textDecoration: "none", color: "inherit" }}>
                            <ListItemButton selected={pathname === item.href}>
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText primary={item.text} />
                            </ListItemButton>
                        </Link>
                    </ListItem>
                ))}
            </List>
        </Stack>
    )
}
